import { z } from 'zod'

export const simulacaoPropostaSchema = z.object({
  id: z.string(),
  empreendimento: z.object({
    idExterno: z.number(),
    nome: z.string(),
  }),
  valorPoupanca: z.number().nullish(),
  valorSaldo: z.number().nullish(),
  valorTotalSimulado: z.number().nullish(),
  entrada: z.array(
    z.object({
      valor: z.number(),
    }),
  ),
  mensais: z.array(
    z.object({
      parcelas: z.array(
        z.object({
          valor: z.number(),
        }),
      ),
    }),
  ),
  intermediarias: z.array(
    z.object({
      parcelas: z.array(
        z.object({
          valor: z.number(),
        }),
      ),
    }),
  ),
  posConclusao: z.array(
    z.object({
      valor: z.number(),
    }),
  ),
  intermediariasPosConclusao: z
    .array(
      z.object({
        parcelas: z.array(
          z.object({
            valor: z.number(),
          }),
        ),
      }),
    )
    .nullish(),
  bloco: z.object({
    idExterno: z.number(),
    nome: z.string(),
  }),
  tipoDeAmortizacao: z.string().nullish(),
  formaDePagamento: z.string().nullish(),
  prazoEmMeses: z.number().nullish(),
})

export const produtoBaseSchema = z.object({
  idExterno: z.number(),
  codigo: z.string(),
  acessorioObrigatorio: z.boolean().nullish(),
  plantaId: z.string().nullish(),
  plantaCodigo: z.number().nullish(),
  plantaDescricao: z.string().nullish(),
  dataMarcacaoAlvenaria: z.string().nullish(),
  acessoriosDaUnidade: z
    .array(
      z.object({
        nome: z.string(),
        acessorios: z.array(
          z.object({
            idExterno: z.number(),
            nome: z.string(),
          }),
        ),
      }),
    )
    .nullish(),
})

export const simulacaoPropostaProdutoSchema = simulacaoPropostaSchema.extend({
  produto: produtoBaseSchema.extend({
    nome: z.string(),
    tipoDoProduto: z.enum(['Unidade', 'Acessorio', 'Lote']),
  }),
})

export type TSimulacaoProposta = z.input<typeof simulacaoPropostaSchema>
export type TSimulacaoPropostaProduto = z.input<typeof simulacaoPropostaProdutoSchema>
